(function() {
  function init() {
    var productJsonEl = document.querySelector('[id^="ProductJson-"]');
    if (!productJsonEl) return;

    var product;
    try { product = JSON.parse(productJsonEl.innerHTML); } catch(e) { return; }

    var variantDeviceMap = {};
    product.variants.forEach(function(v) {
      variantDeviceMap[v.id] = (v.option1 || '').toLowerCase();
    });

    function getSlideForDevice(device) {
      var slides = document.querySelectorAll('.primgSlider [data-slide]');
      var found = null;
      slides.forEach(function(slide) {
        if (found !== null) return;
        var img = slide.querySelector('img');
        if (!img) return;
        var alt = (img.getAttribute('alt') || '').toLowerCase();
        if (alt && alt.indexOf(device) !== -1) {
          found = parseInt(slide.getAttribute('data-slide'));
        }
      });
      return found;
    }

    function goToVariant(variantId) {
      var device = variantDeviceMap[variantId];
      if (!device) return;
      var slideNo = getSlideForDevice(device);
      if (slideNo === null || slideNo === undefined) return;
      try { jQuery('.primgSlider').slick('slickGoTo', slideNo); } catch(e) {}
    }

    var lastVariantId = null;

    function handleVariant(vid) {
      if (!vid || vid === lastVariantId) return;
      lastVariantId = vid;
      goToVariant(vid);
    }

    setInterval(function() {
      var params = new URLSearchParams(window.location.search);
      var vid = parseInt(params.get('variant'));
      handleVariant(vid);
    }, 300);

    var masterSelect = document.querySelector('select[name="id"]');
    if (masterSelect) {
      masterSelect.addEventListener('change', function() {
        handleVariant(parseInt(this.value));
      });
    }

    document.querySelectorAll('[class*="single-option-selector-"]').forEach(function(sel) {
      sel.addEventListener('change', function() {
        setTimeout(function() {
          var ms = document.querySelector('select[name="id"]');
          if (ms) handleVariant(parseInt(ms.value));
        }, 50);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(init, 800); });
  } else {
    setTimeout(init, 800);
  }
})();